/* eslint-disable */
function SwatchesConstructor(obj_json, obj_param) {
  const _ = this

  _.productIsValid = obj_json.available && obj_json.options != 'Title'
  _.product_json = obj_json
  _.options_name = ''
  _.options = ''

  _.viewDesign = window[obj_param['viewDesign']]

  _.contentParent = obj_param['contentParent']
  _.enableHistoryState = Boolean(obj_param['enableHistoryState']) || false
  _.callback = obj_param['callback'] || false
  _.texture_obj = obj_param['externalImagesObject'] || {}
  _.colors_obj = obj_param['externalColors'] || {}
  _.color_with_border = obj_param['colorWithBorder'] || {}

  _.productIsValid && $(_.contentParent).length
    ? _.initSwatches()
    : _.callExternalVariantHandler(
        _.callback,
        obj_json.variants[0],
        _.getJsonObject()
      )
}

SwatchesConstructor.prototype.destroy = function() {
  const $parent = $(this.contentParent)
  $parent.find('a').unbind()
  $parent.find('select').unbind()
  $parent.empty()
}

SwatchesConstructor.prototype.initSwatches = function() {
  const _ = this
  const arr = []
  let options_object = false

  options_object = _.getJsonObject().options
  for (let i = 0; i < options_object.length; i++) {
    arr[i] = Object(options_object[i]).name
  }
  _.options_name = arr

  _.options = getAllOptions(_.getJsonObject().variants)
  const variant_id = _.enableHistoryState && getVariantIdUrl()
  _.createSwatches(variant_id)
}
SwatchesConstructor.prototype.createSwatches = function(variant_id) {
  const _ = this
  const fn = _.viewDesign

  if (isEmpty(_.options)) return false
  const variant = getCurrentVariantById(_.getJsonObject().variants, variant_id)
  const selected_variant_array = getCurrentOptionsArray(variant)
  _.createOptionsView(
    _.contentParent,
    _.options,
    _.options_name,
    selected_variant_array
  )
  _[fn('getFunctionClickHandler')]()

  _.callExternalVariantHandler(_.callback, variant, _.getJsonObject())
}
/* Handlers */
SwatchesConstructor.prototype.buttonHandler = function() {
  const _ = this
  const fn = _.viewDesign
  const $_parent = $(_.contentParent)
  const group_parent_name = fn('getGroupElementName')
  const $_group_parent = $_parent.find(group_parent_name)

  const product_info = _.product_json

  let order_swatches = 'chain_length'
  if (product_info.options[0].name == 'Shape') {
    order_swatches = 'shape'
  } else {
    order_swatches = 'chain_length'
  }

  $_group_parent.find('a').click(function(e) {
    e.preventDefault()
    if ($(this).hasClass('active')) return false
    $_group_parent.find('a').unbind()
    $(this)
      .closest(group_parent_name)
      .find('.active')
      .removeClass('active')
    $(this)
      .parent()
      .addClass('active')
    let str = ''
    if (order_swatches == 'chain_length') {
      $_parent.find('select option:selected').each(function() {
        str += `${$(this).text()} / `
      })
      $_parent
        .find('.active')
        .find('[data-value]')
        .each(function() {
          str += `${$(this).attr('data-value')} / `
        })
    } else {
      $_parent
        .find('.active')
        .find('[data-value]')
        .each(function() {
          str += `${$(this).attr('data-value')} / `
        })
      $_parent.find('select option:selected').each(function() {
        str += `${$(this).text()} / `
      })
    }
    _.endOfTheClickHandler(str)
  })

  $_group_parent.find('select').change(function(e) {
    e.preventDefault()
    let str = ''

    if (order_swatches == 'chain_length') {
      $_parent.find('select option:selected').each(function() {
        str += `${$(this).text()} / `
      })
      $_parent
        .find('.active')
        .find('[data-value]')
        .each(function() {
          str += `${$(this).attr('data-value')} / `
        })
    } else {
      $_parent
        .find('.active')
        .find('[data-value]')
        .each(function() {
          str += `${$(this).attr('data-value')} / `
        })
      $_parent.find('select option:selected').each(function() {
        str += `${$(this).text()} / `
      })
    }
    _.endOfTheClickHandler(str)
  })
}
SwatchesConstructor.prototype.selectHandler = function() {
  const _ = this
  const fn = _.viewDesign

  const $_parent = $(_.contentParent)
  const group_parent_name = fn('getGroupElementName')
  const $_group_parent = $_parent.find(group_parent_name)

  $_group_parent.find('select').change(function() {
    let str = ''
    $_parent.find('select option:selected').each(function() {
      str += `${$(this).text()} / `
    })
    _.endOfTheClickHandler(str)
  })
}
SwatchesConstructor.prototype.endOfTheClickHandler = function(str) {
  const _ = this
  str = str.substring(0, str.length - 3)
  const variant = getCurrentVariantByTitle(_.getJsonObject().variants, str)
  _.enableHistoryState &&
    history.pushState(null, null, `${location.pathname}?variant=${variant.id}`)
  _.createSwatches(variant.id)
}
/* View */
SwatchesConstructor.prototype.createOptionsView = function(
  contentParent,
  value,
  names,
  selected
) {
  const _ = this
  const fn = _.viewDesign

  let $_parent = $(contentParent).empty(),
    texture = _.texture_obj,
    colors = _.colors_obj,
    c_border = _.color_with_border,
    opt1 = '',
    opt2 = '',
    opt3 = '',
    title_key = 'getTitleHtml',
    button_key = 'getButtonHtml',
    wrapperView = ''

  $.each(value, function(key) {
    if (
      key == selected[0] &&
      typeof value[key] === 'object' &&
      key != 'Default Title'
    ) {
      const array_options2 = value[key]
      $.each(array_options2, function(key) {
        if (key == selected[1] && typeof array_options2[key] === 'object') {
          $.each(array_options2[key], function(key) {
            opt3 += fn(button_key, {
              value: key,
              selected: selected[2],
              title: names[2],
              texture,
              colors,
              c_border
            })
          })
        }
        opt2 += fn(button_key, {
          value: key,
          selected: selected[1],
          title: names[1],
          texture,
          colors,
          c_border
        })
      })
    }
    if (key != 'Default Title') {
      opt1 += fn(button_key, {
        value: key,
        selected: selected[0],
        title: names[0],
        texture,
        colors,
        c_border
      })
    }
  })

  const titles = [names[0], names[1], names[2]]
  const values = [opt1, opt2, opt3]
  for (let i = 0; i < values.length; i++) {
    values[i] != '' &&
      $_parent.append(fn('getGroupHtml', { title: titles[i], html: values[i] }))
  }
}
SwatchesConstructor.prototype.getJsonObject = function() {
  return this.product_json
}
SwatchesConstructor.prototype.callExternalVariantHandler = function(
  fn,
  param1,
  param2
) {
  fn && typeof fn === 'function' && fn(param1, param2)
}

/* Public Methods */
function getAllOptions(data) {
  let available = true
  const obj = {}

  for (let i = 0; i < data.length; i++) {
    available = Boolean(data[i].available)
    const opt1 = data[i].option1
    const opt2 = data[i].option2
    const opt3 = data[i].option3

    if (opt1 != null && available) {
      if (opt2 != null) {
        obj[opt1] = obj[opt1] || {}
        if (opt3 != null) {
          obj[opt1][opt2] = obj[opt1][opt2] || {}
          obj[opt1][opt2][opt3] = true
        } else {
          obj[opt1][opt2] = true
        }
      } else {
        obj[opt1] = true
      }
    }
  }
  return obj
}
function getCurrentOptionsArray(variant) {
  let arr = `${variant.option1}%%${variant.option2}%%${variant.option3}`
  arr = arr.replace(/\%\%null/g, '').split('%%')
  console.log(arr)
  return arr
}

function getCurrentVariantById(data, idToLookFor) {
  for (let i = 0; i < data.length; i++) {
    if (!idToLookFor) {
      if (data[i].available) return data[i]
    } else {
      if (data[i].id == idToLookFor) return data[i]
    }
  }
  return data[0]
}
function getCurrentVariantByTitle(data, TitleToLookFor) {
  console.log(`TitleToLookFor${TitleToLookFor}`)
  if (!TitleToLookFor) return data[0]

  let variant_fonded = true

  top: for (let i = 0; i < data.length; i++) {
    const d = `%%${data[i].title}`
    if (
      d.indexOf(`%%${TitleToLookFor}`) > -1 &&
      data[i].available &&
      !variant_fonded
    ) {
      return data[i]
    }
    if (
      data[i].title === TitleToLookFor &&
      data[i].available &&
      variant_fonded
    ) {
      return data[i]
    }
    if (i == data.length - 1) {
      if (TitleToLookFor.indexOf('/') > -1) {
        TitleToLookFor = TitleToLookFor.split('/')
        TitleToLookFor.pop()
        TitleToLookFor =
          TitleToLookFor.length > 1 ? TitleToLookFor.join('/') : TitleToLookFor
        i = 0
        variant_fonded = false
        continue top
      }
    }
  }
  return data[0]
}

function getVariantIdUrl() {
  let path_search = location.search
  if (path_search.indexOf('variant=') > -1) {
    path_search = path_search.match(/variant=\d+/g)
    path_search = parseInt(path_search[0].match(/\d+/g))
  }
  return path_search
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0
}

/* View */
/*
*<div class=".wrapper">
*	<div class="title-options">title</div>
*	<ul class="tags-list">
*		<li><a href="#" data-value="value">value</a></li>
*	</ul>
*</div>
*/
function viewButtons(type, obj) {
  obj = obj || {}

  if (obj.title != 'Chain Length' && obj.title != 'Chain length' && obj.title != 'chain length' && obj.title != 'chain Length') {
    var mainElementName = '.wrapper'
    switch (type) {
      case 'getFunctionClickHandler':
        return 'buttonHandler'

      case 'getGroupElementName':
        return mainElementName

      case 'getGroupHtml':
        var elementName = mainElementName.replace(/([\.#])/g, ''),
          title_html =
            `<div class="title-options text-uppercase">${obj.title}:` +
            `</div>`,
          value_html = obj.html

        return `<div class="${elementName}">${title_html}<ul class="options options-large">${value_html}</ul></div>`

      case 'getButtonHtml':
        var value = obj.value.trim()
        var color = value.toLowerCase()
        var border = obj.c_border.indexOf(value) > -1 ? ' border' : ''
        var classesValues = {
          '14K White Gold': 'White_Gold',
          '18K White Gold': 'White_Gold',
          '14K Yellow Gold': 'Yellow_Gold',
          '18K Yellow Gold': 'Yellow_Gold',
          '14K Rose Gold': 'Rose_Gold',
          '18K Rose Gold': 'Rose_Gold',
          Platinum: 'Platinum'
        }

        var SwatchClassName = classesValues[value]
          ? classesValues[value]
          : value
        color = `,${color}:`
        color =
          obj.colors.indexOf(color) > -1
            ? obj.colors
                .split(color)
                .pop()
                .split(',')
                .shift()
                .trim()
            : false
        var style =
          value in obj.texture
            ? ` style="background:url(${obj.texture[value]})"`
            : ''
        if (style == '' && color) style = ` style="background:${color};"`

        var btn =
          style != ''
            ? `<li> <a href="#" class="options-color${border}" data-value="${value}" title="${value}" ${style}></a></li>`
            : `<li><a href="#" data-value="${value}" title="${value}"> <span class="${SwatchClassName}"> </span> ${value}</a></li>`
        if (obj.value != obj.selected) return btn
        return btn.replace(/<li/, '<li class="active"')
    }
  } else {
    var mainElementName = '.wrapper'
    switch (type) {
      case 'getFunctionClickHandler':
        return 'selectHandler'

      case 'getGroupElementName':
        return mainElementName

      case 'getGroupHtml':
        var elementName = mainElementName.replace(/([\.#])/g, ''),
          title_html =
            `<div class="title-options text-uppercase">${obj.title}:` +
            `</div>`,
          value_html = obj.html
        return `<div class="${elementName} ${
          obj.title
        }">${title_html}<div class="select-wrapper setting-sel"><select id="SingleOptionSelector-0" class="form-control select-inline"><option value="">CHOOSE CHAIN LENGTH</option>${value_html}</select></div></div>`

      case 'getButtonHtml':
        var btn = `<option>${obj.value.trim()}</option>`
        if (obj.value != obj.selected) return btn
        return btn.replace(/<option/, '<option selected')
    }
  }
}
/*
*<div class=".wrapper">
*	<div class="title-options">title</div>
*	<ul>
*		<li><select><option></option>...</select></li>
*	</ul>
*</div>
*/
function viewSelect(type, obj) {
  obj = obj || {}
  const mainElementName = '.wrapper'
  switch (type) {
    case 'getFunctionClickHandler':
      return 'selectHandler'

    case 'getGroupElementName':
      return mainElementName

    case 'getGroupHtml':
      var elementName = mainElementName.replace(/([\.#])/g, ''),
        title_html =
          `<div class="title-options text-uppercase">${obj.title}:` + `</div>`,
        value_html = obj.html
      return `<div class="${elementName} ${
        obj.title
      }">${title_html}<select class="form-control select-inline"><option  value=""> CHOOSE CHAIN LENGTH </option>${value_html}</select></div>`

    case 'getButtonHtml':
      var btn = `<option>${obj.value.trim()}</option>`
      if (obj.value != obj.selected) return btn
      return btn.replace(/<option/, '<option selected')
  }
}
